
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_2p5ev_103",
  "slider": "awsui_slider_pcgz5_2p5ev_143",
  "slider-track": "awsui_slider-track_pcgz5_2p5ev_147",
  "slider-range": "awsui_slider-range_pcgz5_2p5ev_147",
  "disabled": "awsui_disabled_pcgz5_2p5ev_162",
  "error": "awsui_error_pcgz5_2p5ev_171",
  "warning": "awsui_warning_pcgz5_2p5ev_174",
  "active": "awsui_active_pcgz5_2p5ev_177",
  "error-active": "awsui_error-active_pcgz5_2p5ev_180",
  "warning-active": "awsui_warning-active_pcgz5_2p5ev_183",
  "labels": "awsui_labels_pcgz5_2p5ev_190",
  "labels-noref": "awsui_labels-noref_pcgz5_2p5ev_196",
  "labels-reference": "awsui_labels-reference_pcgz5_2p5ev_199",
  "labels-min": "awsui_labels-min_pcgz5_2p5ev_206",
  "labels-max": "awsui_labels-max_pcgz5_2p5ev_212",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_2p5ev_220",
  "ticks": "awsui_ticks_pcgz5_2p5ev_238",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_2p5ev_244",
  "tick": "awsui_tick_pcgz5_2p5ev_238",
  "middle": "awsui_middle_pcgz5_2p5ev_259",
  "filled": "awsui_filled_pcgz5_2p5ev_262",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_2p5ev_284",
  "thumb": "awsui_thumb_pcgz5_2p5ev_292",
  "min": "awsui_min_pcgz5_2p5ev_307",
  "max": "awsui_max_pcgz5_2p5ev_310"
};
  